"use client";

import { Mail, MessageCircle, BookOpen, Code2, CalendarDays } from "@/components/icons";
import { DEVELOPERS_URL, HELP_URL, CONTACT_SALES_URL } from "@/lib/constants";

export const PRIMARY_CARDS = [
  {
    icon: <Mail size={20} />,
    title: "Sales",
    description:
      "Speak to our sales team about plans, pricing, enterprise contracts, or request a demo.",
    cta: "Talk to Sales",
    href: CONTACT_SALES_URL,
    external: false,
    accent: "var(--yellow-accent)",
  },
  {
    icon: <MessageCircle size={20} />,
    title: "Help & support",
    description: "Ask product questions, report problems, or leave feedback.",
    cta: "Contact support",
    href: "/contact/support",
    external: false,
    accent: "var(--brand-green)",
  },
];

export const SECONDARY_CARDS = [
  {
    icon: <CalendarDays size={20} />,
    title: "Book a Demo",
    description:
      "See Proxidize in action. Schedule a personalized walkthrough with our team and find the right setup for your use case.",
    cta: "Book a demo",
    href: "/request-a-demo",
    external: false,
  },
  {
    icon: <BookOpen size={20} />,
    title: "Help Center",
    description:
      "Browse step-by-step guides, troubleshooting articles, and answers to common questions.",
    cta: "Visit help Center",
    href: HELP_URL,
    external: true,
  },
  {
    icon: <Code2 size={20} />,
    title: "Developers",
    description: "Learn how to use the REST API and TypeScript SDK to extend Proxidize.",
    cta: "Proxidize API",
    href: DEVELOPERS_URL,
    external: true,
  },
];
